import { render, staticRenderFns } from "./PageCom.vue?vue&type=template&id=3d06a514&scoped=true"
import script from "./PageCom.vue?vue&type=script&lang=js"
export * from "./PageCom.vue?vue&type=script&lang=js"
import style0 from "./PageCom.vue?vue&type=style&index=0&id=3d06a514&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d06a514",
  null
  
)

export default component.exports